import { useRolodexEntries } from 'features/rolodex'
import { useMemo } from 'react'
import { RolodexEntryType } from 'types'

const ALL_PERMS_DEFAULT_SITE_ID = 'atlantic-deer-island'

export type DefaultOrgSiteReturn =
  | {
      isLoading: true
      hasError: false
    }
  | {
      isLoading: false
      siteId: string
      organizationId: string
      hasError: false
    }
  | {
      isLoading: false
      hasError: true
      error: Error
    }

export function useGetDefaultOrgSite(): DefaultOrgSiteReturn {
  const { sites, isLoading, hasEverLoaded, getSite } = useRolodexEntries({
    type: [RolodexEntryType.SITE, RolodexEntryType.ORGANIZATION],
    order_by: [{ key: 'name', descending: 'false' }],
  })

  const siteToUse = getSite(ALL_PERMS_DEFAULT_SITE_ID) ?? sites.at(0)

  return useMemo(() => {
    if (isLoading || !hasEverLoaded) {
      return { isLoading: true, hasError: false }
    }

    if (!siteToUse) {
      return {
        isLoading: false,
        hasError: true,
        error: new Error(
          'User has access to no sites nor organizations. Please contact support.'
        ),
      }
    }

    return {
      isLoading: false,
      hasError: false,
      siteId: siteToUse.id,
      organizationId: siteToUse.tags[RolodexEntryType.ORGANIZATION],
    }
  }, [isLoading, hasEverLoaded, siteToUse])
}
